<pr-form
  (onSubmit)="submit()"
  title="Paramétrez votre simulation"
  [formGroup]="form"
>
  <h3>Paramètres du bien loué</h3>

  <pr-input-radio
    formControlName="propertyType"
    label="Type de bien"
    [options]="[
      { value: 'HOUSE', label: 'Maison' },
      { value: 'APPARTMENT', label: 'Appartement' },
    ]"
  >
  </pr-input-radio>

  <pr-input label="Adresse" [derrors]="derrors">
    <input formControlName="addressStreet" type="text" />
  </pr-input>

  <pr-input label="Code Postal" [derrors]="derrors">
    <input formControlName="addressZipCode" type="number" />
  </pr-input>

  <pr-input label="Ville" [derrors]="derrors">
    <input formControlName="addressCity" type="string" />
  </pr-input>

  <pr-input label="Valeur du bien" suffix="€" [derrors]="derrors">
    <input formControlName="propertyValue" type="number" />
  </pr-input>

  <pr-input label="Surface du bien" suffix="m²" [derrors]="derrors">
    <input formControlName="areaSize" type="number" />
  </pr-input>

  <pr-input label="Valeur du mobilier" suffix="€" [derrors]="derrors">
    <input formControlName="furnitureValue" type="number" />
  </pr-input>

  <pr-input label="Montant des travaux" suffix="€" [derrors]="derrors">
    <input formControlName="workAmount" type="number" />
  </pr-input>

  <pr-input label="Loyer mensuel" suffix="€/mois" [derrors]="derrors">
    <input formControlName="rent" type="number" />
  </pr-input>

  <h3>Financement</h3>

  <pr-input-radio
    formControlName="cashOrCredit"
    label="Investissement"
    [options]="[
      { value: 'CASH', label: 'Cash' },
      { value: 'CREDIT', label: 'Credit' },
    ]"
  >
  </pr-input-radio>

  <pr-input
    [hidden]="inCash"
    label="Montant emprunté"
    suffix="€"
    [derrors]="derrors"
  >
    <input formControlName="borrowedAmount" type="number" />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Taux d'interêt"
    suffix="%"
    [derrors]="derrors"
  >
    <input formControlName="loanInterestRate" type="number" />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Assurance annuelle"
    suffix="€/an"
    [derrors]="derrors"
  >
    <input formControlName="annualyInsurance" type="number" />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Durée de l’emprunt"
    suffix="ans"
    [derrors]="derrors"
  >
    <input formControlName="loanDuration" type="number" />
  </pr-input>

  <pr-input-date
    [hidden]="inCash"
    formControlName="loanStartDate"
    label="Date de début d’emprunt"
    [derrors]="derrors"
  ></pr-input-date>

  <h3>Charge</h3>

  <pr-input label="Frais d'agence" suffix="€" [derrors]="derrors">
    <input formControlName="agencyFees" type="number" />
  </pr-input>

  <pr-input label="Taxe foncière" suffix="€" [derrors]="derrors">
    <input formControlName="propertyTax" type="number" />
  </pr-input>

  <pr-input label="Charges de copropriété" suffix="€/an" [derrors]="derrors">
    <input formControlName="annuallyCharge" type="number" />
  </pr-input>

  <pr-input label="Autre charges" suffix="€/an" [derrors]="derrors">
    <input formControlName="otherFees" type="number" />
  </pr-input>
</pr-form>
